import { commodityOptions } from 'data';
import NumberUtils from 'helpers/numberUtils';
import React from 'react';

const numberUtils = new NumberUtils();
const formatCurrencyOrBlank = (value) =>
  value === null || value === undefined || value === ''
    ? ''
    : numberUtils.formatToCurrency(Number(value));

const Commodities = ({ commodities }) => {
  return (
    <div className="max-w-6xl mx-auto p-6 bg-white">
      <h2 className="text-2xl font-bold text-red-500 text-center mb-2">
        Commodities Hauled
      </h2>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-[#666666] text-white font-bold">
              <th className="px-4 py-2 text-left">Commodity Type</th>
              <th className="px-4 py-2 text-center">% of Hauls</th>
              <th className="px-4 py-2 text-right">Deductible</th>
            </tr>
          </thead>
          <tbody>
            {commodities?.map((commodity, index) => (
              <tr
                key={index}
                className={
                  index % 2 === 0
                    ? 'bg-white text-sm'
                    : 'bg-gray-50 text-sm'
                }
              >
                <td className="px-4 py-2 text-left font-bold">
                  {
                    commodityOptions?.find(
                      (cmodt) =>
                        cmodt.value === commodity.commodityKey
                    )?.label
                  }
                </td>
                <td className="px-4 py-2 text-center">
                  {commodity.commodityPercentage} %
                </td>
                <td className="px-4 py-2 text-right">
                  {formatCurrencyOrBlank(commodity.deductible)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Commodities;
